// Styles
import styles from './Layout.module.sass'

interface ContainerProps {
  children: React.ReactNode
}

const Container = ({ children }: ContainerProps) => (
  <div className={styles.container}>{children}</div>
)

interface RowProps {
  padding?: number
  position?: 'space-between' | 'center' | 'flex-start' | 'flex-end'
  align?: 'center'
  children: React.ReactNode
}
const Row = ({ children, padding, position, align }: RowProps) => (
  <div
    className={`
    ${styles.row} 
    ${padding ? `${styles[`padding-${padding}`]}` : ''}
    ${position ? `${styles[`position-${position}`]}` : ''}
    ${align ? `${styles[`align-${align}`]}` : ''}
  `}
  >
    {children}
  </div>
)

interface ColumnProps {
  column: number
  gutter: number
  children: React.ReactNode
}
//lg-4-3
const Column = ({ children, column, gutter }: ColumnProps) => (
  <div
    className={`
    ${styles[`col-${column}-${gutter}`]}
  `}
  >
    {children}
  </div>
)

export { Container, Row, Column }
